var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":""}},[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"itemsAction":_vm.tableAction}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }